import React, { useContext, useEffect, useState } from "react";
import "./CompliantListTable.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Form, Pagination, Table } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import Button from "react-bootstrap/Button";
import StatusChangemodal from "../all-table-modal/StatusChangemodal";
import CompalintTransferModal from "../all-table-modal/CompalintTransferModal";
import AddNewComplaintModal from "../all-table-modal/AddNewComplaintModal";
import ScheduleDateChangemodal from "../all-table-modal/ScheduleDateModel";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Context } from "../../../../utils/context";
import CustomPagination from "../../../common/CustomPagination";
import { useLocation } from "react-router-dom";
import DeleteModal from "../all-table-modal/DeleteModal";
import AssignEngineerModel from "../all-table-modal/AssignEngineerModel";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import Feedback_modal from "../../../common/modal/feedback_modal/Feedback_modal";
import EngineerFeedbackModal from "../../../common/modal/engineer_feedback_modal/EngineerFeedbackModal";
import ComplaintAssignProductShow from "../../../common/modal/complaint_assign_product_show/ComplaintAssignProductShow";

const ComplaintListTable = (props) => {
  const [showFeedback, setShowFeedback] = useState(false);

  const handleCloseFeedback = () => setShowFeedback(false);
  const handleShowFeedback = () => setShowFeedback(true);
  const location = useLocation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const {
    getData,
    getDownloadDataExcel,
    Select2Data,
    deleteData,
    setComplaintStatus,
    complaintstatus,
    IMG_URL,
    Per_Page_Dropdown,
  } = useContext(Context);
  const [modalShow, setModalShow] = useState(false);
  const [modalComplaint, setModalComplaint] = useState(false);
  const [modalScheduleDate, setModalScheduleDate] = useState(false);
  const [modalAssignEngineer, setModalAssignEngineer] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [perPage, setperPage] = useState(10);
  const [option, setOption] = useState();

  const [feedbackModal, setFeedbackModal] = useState(false);
  const [engineerFeedbackModal, setEngineerFeedbackModal] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [engineerFeedback, setEngineerFeedback] = useState("");

  const [assignProductShow, setAssignProductshow] = useState(false);

  const [complaintID, setComplaintID] = useState(false);
  const [complaintID2, setComplaintID2] = useState("");

  const handleFromChange = (e) => {
    const fromDate = e.target.value;
    setFrom(fromDate);
    setTo("");
  };

  const handleToChange = (e) => {
    const toDate = e.target.value;
    setTo(toDate);
  };

  const [reset, setReset] = useState();
  const [status, setStatus] = useState("");
  const [searchStatus, setSearchStatus] = useState(complaintstatus);
  const [priority, setPriority] = useState("");
  const [product, setProduct] = useState("");
  const [searchPriority, setSearchPriority] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  const [data, setData] = useState({ totalPages: 1, currentPage: 1 });
  const [dashboard, setDashborad] = useState({});

  const [totalPages, settotalPages] = useState();

  const [onPageChange, setonPageChange] = useState(1);

  const handlePageChange = (pageNumber) => {

    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}>
        {page}
      </Pagination.Item>,
    );
  }

  const getAllData = async () => {
    {
      const res = await getData(
        `/complaint-management/complaints?page=${onPageChange}&per_page=${perPage}&term=${
          search || ""
        }&from=${from || ""}&to=${to || ""}&complaint_status=${
          searchStatus?.value || ""
        }&complaint_priorities=${searchPriority?.value || ""}&product=${
          searchProduct || ""
        }`,
      );
      if (res?.data) {
        setData(res?.data);
        setCurrentPage(res?.data?.currentPage);
        setperPage(res?.data?.per_page);
        setSearch(res?.data?.search_name);
        setFrom(res?.data?.from);
        setTo(res?.data?.to);
        setStatus(res?.data?.search_name);
        setPriority(res?.data?.search_name);
        settotalPages(res?.data?.totalPages);
        setOption(await Per_Page_Dropdown(res?.data?.totalEntries));

        const newData = res?.data?.data;
        if (newData) {
          const newIds = newData.map((d) => d?.id);
          setAllChecked(newIds);
        }
      }
    }

    const res2 = await getData("/masters/all-complaint-status");

    if (res2?.success) {
      setStatus(await Select2Data(res2?.data, "complaint_status_id"));
    }

    const res3 = await getData("/masters/all-complaint-priorities");

    if (res3?.success) {
      setPriority(await Select2Data(res3?.data));
    }

    const prod = await getData("/masters/allproducts-list");

    if (prod?.success) {
      setProduct(await Select2Data(prod?.data));
    }

    {
      const res = await getData(`/complaint-management/dashboard`);
      setDashborad(res?.data);
    }
  };

  useEffect(() => {
    getAllData();
  }, [modalAdd, currentPage, modalComplaint, modalShow, reset, onPageChange]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    if (statusParam) {
      setSearchStatus(statusParam);
    }
  }, [location.search]);
  // Modal
  const [lgShow, setLgShow] = useState(false);
  const [statusandtransfer, setstatusandtransfer] = useState({});
  const [view, setview] = useState(false);

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  const HandleDownload = async () => {
    // if (selectAllChecked.length == 0) {
    //   alert("Please Select Atleast One Record");
    // } else {
    try {
      await getDownloadDataExcel(
        "/complaint-management/complaints/download",
        selectAllChecked,
        "Complaint List",
      );
    } catch (error) {
      console.error("Error:", error);
    }
    // }
  };

  const [modelDelete, setModelDelete] = useState(false);
  const deleteRecord = async (id = 0) => {
  
    const res = await deleteData(`/complaint-management/complaints/${id}`);
    if (res?.success) {
      await setModelDelete(res?.success);
    }

    setTimeout(() => {
      setModelDelete(0);
      // props.handleClose2();
      handleClose();
      getAllData();
    }, 1000);
  };

  const handleDownloadReport = async (invoice) => {
    try {
      // const response = await getData(`/order/invoice-download/${id}`);

      const filePath = invoice;

      if (!filePath) {
        console.error("File path is undefined or null");
        return;
      }

      const url = `${IMG_URL}/${filePath}`;

      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.click();
    } catch (error) {
      console.error("Error opening file:", error);
    }
  };

  return (
    <>
      <section className="complaint-list-table">
        <div className="card-section">
          <Row>
            <Col xl={3} lg={6} md={6}>
              <div className=" d-flex registered-number">
                <div className="circle-holder">
                  <img
                    className="ticket-img"
                    src={process.env.PUBLIC_URL + "/assets/Image/tickets.png"}
                  />
                  {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                </div>
                <div className="text-holder">
                  <p>Complaint Registred</p>
                  <h5> {dashboard?.complaint_registred}</h5>
                </div>
              </div>
            </Col>
            <Col xl={3} lg={6} md={6}>
              <div className=" d-flex registered-number">
                <div className="circle-holder1">
                  <img
                    className="ticket-img"
                    src={process.env.PUBLIC_URL + "/assets/Image/tickets.png"}
                  />
                  {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                </div>
                <div className="text-holder">
                  <p>Pending Complaint</p>
                  <h5> {dashboard?.pending_registred}</h5>
                </div>
              </div>
            </Col>
            <Col xl={3} lg={6} md={6}>
              <div className=" d-flex  mt-xl-0 mt-lg-3 mt-md-3 registered-number">
                <div className="circle-holder2">
                  <img
                    className="ticket-img"
                    src={process.env.PUBLIC_URL + "/assets/Image/tickets.png"}
                  />
                  {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                </div>
                <div className="text-holder">
                  <p>Closed Complaints</p>
                  <h5> {dashboard?.closed_registred}</h5>
                </div>
              </div>
            </Col>
            <Col xl={3} lg={6} md={6}>
              <div className=" d-flex mt-xl-0 mt-lg-3 mt-md-3">
                <div className="circle-holder3">
                  <img
                    className="ticket-img"
                    src={process.env.PUBLIC_URL + "/assets/Image/tickets.png"}
                  />
                  {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                </div>
                <div className="text-holder">
                  <p>Rejected Complaints</p>
                  <h5> {dashboard?.rejected_registred}</h5>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <div className="heading-holder mt-5">
            <h4>Complaint List</h4>
          </div>

          <div className="main-class-report-table">
            <Row>
              <Col xl={3} lg={3} md={5} sm={12}>
                <Form.Label>Search</Form.Label>
                <input
                  type="text"
                  className="form-control"
                  id=""
                  placeholder="Customer Name"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target?.value);
                    setonPageChange(1);
                  }}
                />
              </Col>
              <Col xl={2} lg={3} md={5} sm={12}>
                <Form.Label>Complaint Status</Form.Label>
                <Select
                  placeholder="Status"
                  className="custom-select"
                  onChange={(e) => {
                    setSearchStatus(e);
                    setonPageChange(1);
                  }}
                  value={searchStatus}
                  options={status}
                />
              </Col>

              <Col xl={2} lg={3} md={5} sm={12}>
                <Form.Label> Schedule From</Form.Label>
                <input
                  type="date"
                  className="form-control"
                  value={from}
                  onChange={handleFromChange}
                />
              </Col>
              <Col xl={2} lg={3} md={5} sm={12}>
                <Form.Label> Schedule To</Form.Label>
                <input
                  type="date"
                  className="form-control"
                  value={to}
                  onChange={handleToChange}
                  min={from} // Set the minimum allowed date for "To" as the "From" date
                />
              </Col>

              <Col xl={2} lg={3} md={5} sm={12}>
                <Form.Label>Sory By</Form.Label>
                <Select
                  placeholder="Priority"
                  className="custom-select"
                  onChange={(e) => {
                    setSearchPriority(e);
                    setonPageChange(1);
                  }}
                  value={searchPriority}
                  options={priority}
                />
              </Col>

              {/* <Col xl={2} lg={3} md={5} sm={12}>
                <Form.Label>Sory By Product</Form.Label>
                <Select
                  placeholder="Products"
                  className="custom-select"
                  onChange={(e) => {
                    setSearchProduct(e);
                  }}
                  value={searchProduct}
                  options={product}
                />
              </Col> */}

              <Col xl={3} lg={3} md={5} sm={12}>
                <Form.Label>Search Item</Form.Label>
                <input
                  type="text"
                  className="form-control"
                  id=""
                  placeholder="Item Name"
                  value={searchProduct}
                  onChange={(e) => {
                    setSearchProduct(e.target?.value);
                    setonPageChange(1);
                  }}
                />
              </Col>

              <Col xl={5} lg={5} md={6} sm={12}>
                <Row className="mt-1">
                  <Col xl={2} lg={2} md={2} sm={3}>
                    <Form.Label></Form.Label>
                    <div className="Search me-2">
                      <button
                        type="button"
                        onClick={getAllData}
                        className="reset-btn">
                        <img src={search1} className="search" alt="" />
                      </button>
                    </div>
                  </Col>
                  <Col xl={3} lg={3} md={2} sm={6}>
                    <Form.Label></Form.Label>
                    <div className="Search-1">
                      <button
                        type="button"
                        onClick={() => {
                          setSearch("");
                          setFrom("");
                          setTo("");
                          setSearchStatus("");
                          setSearchPriority("");
                          setperPage("");
                          setSearchProduct("");
                          setReset(!reset);
                        }}
                        className="reset-btn">
                        Reset
                      </button>
                    </div>
                  </Col>

                  {/* <Col xl={7} lg={6} md={8} sm={6}>
                    <Form.Label>Download data in Excel</Form.Label>
                    <br />
                    <FontAwesomeIcon
                      icon="fa-solid fa-file-lines"
                      className="pdf-icon"
                      variant="success"
                      // className="btn btn-view"
                      onClick={HandleDownload}
                    />
                  </Col> */}
                </Row>
              </Col>
            </Row>
            <div className="brownborder-report mt-3"></div>
            <Row>
              <div className="col-md-8">
                <div className="d-flex my-3">
                  <div className="status-button me-2">
                    <Button
                      className="btn tansfer-btn"
                      onClick={() => {
                        if (selectAllChecked.length) {
                          setModalShow(true);
                        } else {
                          alert("Please Select At Least One List");
                        }
                      }}>
                      Status Change
                    </Button>
                    <StatusChangemodal
                      show={modalShow}
                      ids={selectAllChecked}
                      onHide={() => setModalShow(false)}
                    />
                  </div>

                  <div className="status-button">
                    <Button
                      className="btn tansfer-btn"
                      onClick={() => {
                        if (selectAllChecked.length) {
                          setModalComplaint(true);
                        } else {
                          alert("Please Select At Least One List");
                        }
                      }}>
                      Complaint Transfer
                    </Button>
                    <CompalintTransferModal
                      ids={selectAllChecked}
                      show={modalComplaint}
                      onHide={() => setModalComplaint(false)}
                    />
                  </div>

                  <div className="status-button">
                    <Button
                      className="btn tansfer-btn"
                      onClick={() => {
                        if (selectAllChecked.length) {
                          setModalScheduleDate(true);
                        } else {
                          alert("Please Select At Least One List");
                        }
                      }}>
                      Complaint Schedule Time & Date
                    </Button>
                    <ScheduleDateChangemodal
                      ids={selectAllChecked}
                      getAllData={getAllData}
                      show={modalScheduleDate}
                      onHide={() => setModalScheduleDate(false)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="btn_holder">
                  <div className="status-button">
                    <Button
                      className="add-neww-btn"
                      onClick={() => {
                        if (selectAllChecked.length) {
                          setModalAssignEngineer(true);
                        } else {
                          alert("Please Select At Least One List");
                        }
                      }}>
                      <FontAwesomeIcon
                        icon="fa-solid fa-plus"
                        className="fonticn"
                      />{" "}
                      Assign Engineer
                    </Button>
                    <AssignEngineerModel
                      ids={selectAllChecked}
                      show={modalAssignEngineer}
                      getAllData={getAllData}
                      onHide={() => setModalAssignEngineer(false)}
                    />
                  </div>

                  <div className="status-button text-end my-3">
                    <Button
                      variant="primary"
                      className="add-neww-btn"
                      onClick={() => setModalAdd(true)}>
                      <FontAwesomeIcon
                        icon="fa-solid fa-plus"
                        className="fonticn"
                      />{" "}
                      Add New Complaint
                    </Button>
                    <AddNewComplaintModal
                      view={view}
                      show={modalAdd}
                      onHide={() => {
                        setModalAdd(false);
                        setview(false);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <div className="table-sec-main">
                <Table responsive>
                  <thead>
                    <tr className="heads-main">
                      <th>
                        {/* <input
                          type="checkbox"
                          value="selectAll"
                          checked={
                            allChecked.length === selectAllChecked.length
                          }
                          onChange={handleChange}
                          id="selectAll"
                          className="me-1"></input> */}
                        Select
                      </th>
                      <th>Complatint No.</th>
                      <th>Customer Name</th>
                      {/* <th>Complaint Type</th> */}
                      {/* <th>Visit Type</th> */}
                      <th>Charges (rs)</th>
                      {/* <th>Bill</th> */}
                      {/* <th>Description</th> */}
                      {/* <th>Call by whom</th> */}
                      <th>Service Engineer</th>
                      <th>Schedule Date</th>
                      <th>Schedule Time</th>
                      {/* <th>Item Name</th> */}
                      {/* <th>Item Serial Number</th> */}
                      {/* <th>Source</th> */}
                      <th>Service Call No</th>
                      <th>Completion Date</th>
                      {/* <th>Handled by</th> */}
                      <th>Mobile No for SMS</th>
                      {/* <th>Remark</th> */}
                      <th>Case Priority</th>
                      {/* <th>Customer Feedback</th> */}
                      {/* <th>Engineer Feedback</th> */}
                      <th>Products With Engineer</th>
                      {/* <th>Support</th> */}
                      {/* <th>Support Month</th> */}
                      <th>Status</th>
                      <th>Action</th>
                      <th>CSR Report</th>
                    </tr>
                  </thead>
                  <tbody className="table-body-holder">
                    {data?.data?.map((d, index) => (
                      <tr className="heads-main" key={index}>
                        <td>
                          {d?.support_status == 0 &&
                          d?.complaint_status_id !== 3 ? (
                            <input
                              type="checkbox"
                              className="form-check-input"
                              value={d?.id}
                              name="perselected"
                              checked={selectAllChecked.includes(d?.id)}
                              onChange={handleChange}
                              id="flexCheckDefault"></input>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{d.complaints_no || "-"}</td>
                        <td>{d.customer?.name || "-"}</td>
                        {/* <td>{d.complaint_type?.name || "-"}</td> */}
                        {/* <td>{d.visit_type?.name || "-"}</td> */}
                        <td>₹ {d.charges || 0}</td>
                        {/* <td>{d.bill || "-"}</td> */}
                        {/* <td>{d.description || "-"}</td> */}
                        {/* <td>{d.call_by_whom || "-"}</td> */}
                        {/* <td>{d.reference_no}</td> */}
                        <td>{d.service_engineer?.name || "-"}</td>
                        <td>{d.schedule_date || "-"}</td>
                        <td>{d.schedule_time || "-"}</td>
                        {/* <td>{d.product?.name || "-"}</td> */}
                        {/* <td>{d.item_serial_no || "-"}</td> */}
                        {/* <td>XXXXX</td> */}
                        {/* <td>{d.complaint_source?.name || "-"}</td> */}
                        <td>{d.service_call_no || "-"}</td>
                        <td>{d.completion_time || "-"}</td>
                        {/* <td>{d.handled_by?.name || "-"}</td> */}
                        <td>{d.mobile_no_for_sms || "-"}</td>
                        {/* <td>{d.remark || "-"}</td> */}
                        <td
                          className="btn"
                          style={{
                            color:
                              d.complaint_priority?.name === "High"
                                ? "#fff"
                                : d.complaint_priority?.name === "Medium"
                                  ? "#fff"
                                  : "#fff",

                            background:
                              d.complaint_priority?.name === "High"
                                ? "#f3060aff"
                                : d.complaint_priority?.name === "Medium"
                                  ? "#927e0bff"
                                  : "#024e1fff",
                            textAlign: "center",
                            width: "80px",
                            marginTop: "12px",
                            padding: "3px",
                          }}>
                          {d.complaint_priority?.name || "-"}
                        </td>
                        {/* <td>
                          <Button
                            className="add-neww-btn"
                            onClick={() => {
                              setFeedbackModal(true);
                              setFeedback(d?.customer_feedback);
                            }}>
                            View
                          </Button>
                        </td> */}

                        {/* <td>
                          <Button
                            className="add-neww-btn"
                            onClick={() => {
                              setEngineerFeedbackModal(true);
                              setEngineerFeedback(
                                d?.complaint_customer_feedback
                              );
                            }}>
                            View
                          </Button>
                        </td> */}

                        <td>
                          <Button
                            className="add-neww-btn"
                            onClick={() => {
                              setAssignProductshow(true);
                              setComplaintID(d?.id);
                              setComplaintID2(d?.complaints_no);
                            }}>
                            Assign Products
                          </Button>
                        </td>
                        {/* <td>{d.support_status ? "True" : "False"}</td> */}
                        {/* <td>{d.support_month || "-"}</td> */}

                        <td>
                          <div
                            className="btn"
                            // style={{
                            //   backgroundColor:
                            //     d.complaint_status?.name === "Rejected"
                            //       ? "#F42B2D"
                            //       : d.complaint_status?.name === "Resolved"
                            //       ? "#FFD500"
                            //       : d.complaint_status?.name === "Hold"
                            //       ? "#D1D801"
                            //       : d.complaint_status?.name === "New"
                            //       ? "#9DD9F3"
                            //       : "",
                            //   color:
                            //     d.complaint_status?.name === "Rejected"
                            //       ? "#FFF"
                            //       : "#000",
                            // }}

                            style={{
                              color:
                                d.complaint_status?.name === "Rejected"
                                  ? "#FFF"
                                  : "#fdfdfdff",

                              backgroundColor:
                                d.complaint_status?.name === "Rejected"
                                  ? "#fa0707ff"
                                  : d.complaint_status?.name === "Resolved"
                                    ? "#35bb0cff"
                                    : d.complaint_status?.name === "Hold"
                                      ? "#eaf10eff"
                                      : d.complaint_status?.name === "New"
                                        ? "#69c6eeff"
                                        : d.complaint_status?.name === "Pending"
                                          ? "#86840fff"
                                          : "",
                              textAlign: "center",
                              width: "80px",
                              marginTop: "6px",
                              padding: "3px",
                              fontSize: "12px",
                            }}>
                            {d.complaint_status?.name || "-"}
                          </div>
                        </td>

                        <td>
                          <FontAwesomeIcon
                            icon="fa-solid fa-eye"
                            onClick={() => {
                              setModalAdd(d?.id);
                              setview(true);
                            }}
                            className="action-icon me-2"
                          />
                          {d?.complaint_status_id !== 3 &&
                            d?.complaint_status_id !== 4 && (
                              <FontAwesomeIcon
                                icon="fa-solid fa-pen"
                                onClick={() => setModalAdd(d?.id)}
                                className="action-icon me-2"
                              />
                            )}
                          <FontAwesomeIcon
                            icon="fa-solid fa-trash-can"
                            onClick={() => deleteRecord(d?.id)}
                            // onClick={() => deleteRecord(d?.id)}
                            className="action-icon me-2"
                          />{" "}
                          {/*delete record modal  */}
                          <DeleteModal
                            show={modelDelete}
                            onHide={() => setModelDelete(false)}
                          />
                          <FontAwesomeIcon
                            icon="fa-solid fa-clock-rotate-left"
                            onClick={() => {
                              setstatusandtransfer(d);
                              setLgShow(true);
                            }}
                            className="action-icon"
                          />
                        </td>

                        <td>
                          {d?.csr ? (
                            <div className="action_btns">
                              <Button
                                className="add-neww-btn"
                                onClick={() => handleDownloadReport(d?.csr)}>
                                Download
                              </Button>
                            </div>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <div className="paginationss mt-4">
                  <Feedback_modal
                    show={feedbackModal}
                    onHide={() => setFeedbackModal(false)}
                    feedback={feedback}
                  />
                </div>

                <div className="paginationss mt-4">
                  <EngineerFeedbackModal
                    show={engineerFeedbackModal}
                    onHide={() => setEngineerFeedbackModal(false)}
                    feedback={engineerFeedback}
                  />
                </div>

                <div className="paginationss mt-4">
                  <ComplaintAssignProductShow
                    show={assignProductShow}
                    onHide={() => setAssignProductshow(false)}
                    feedback={engineerFeedback}
                    id={complaintID}
                    id2={complaintID2}
                  />
                </div>
              </div>

              <div className="paginationss mt-4">
                <Pagination_Holder
                  onPageChange={currentPage}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Row>
          </div>
        </Row>
      </section>
      {/* History Modal */}
      <div>
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          className="history-modal"
          centered>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              <h6 className="mt-2">
                History{" "}
                <span>
                  {" "}
                  ( Customer Name : {statusandtransfer?.customer_name} ,
                  Complaint Number : {statusandtransfer?.complaints_no})
                </span>
              </h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row>
                <Nav variant="pills" className="">
                  <Nav.Item>
                    <Nav.Link eventKey="first">Status Change</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="second">Complaint Transfer</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    {" "}
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Status Change</th>
                          <th>Remark</th>
                          <th>Date</th>
                          <th>Time</th>
                        </tr>
                      </thead>
                      <tbody className="table-body-holder">
                        {statusandtransfer?.complaint_status_histories?.map(
                          (data, index) => {
                            const dt = new Date(data?.updatedAt);

                            return (
                              <tr key={index}>
                                <td>
                                  <p className="status-table-p">
                                    {data?.user?.name} Change status to{" "}
                                    <span className="statue-span">
                                      {data?.complaint_status?.name || "New"}
                                    </span>
                                  </p>
                                </td>

                                <td>{data?.remark || "-"}</td>

                                <td>
                                  {data?.date || dt.toISOString().split("T")[0]}
                                </td>
                                <td>
                                  {data?.time ||
                                    dt.toLocaleTimeString("en-GB", {
                                      hour12: false,
                                    })}
                                </td>
                              </tr>
                            );
                          },
                        )}
                      </tbody>
                    </Table>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    {" "}
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Transfer</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Remark</th>
                        </tr>
                      </thead>
                      <tbody className="table-body-holder">
                        {statusandtransfer?.complaint_transfer_histories?.map(
                          (data, index) => (
                            <tr key={index}>
                              <td>
                                <p className="table-p-tag">
                                  <span className="p-tag-span1">
                                    {data?.transfer_by?.name}
                                  </span>{" "}
                                  Transfer This Complaint To{" "}
                                  <span className="p-tag-span1">
                                    {data?.transfer_to?.name}
                                  </span>
                                </p>
                              </td>
                              <td>{data?.date || "-"}</td>
                              <td>{data?.time || "-"}</td>
                              <td>{data?.remark || "-"}</td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </Table>
                  </Tab.Pane>
                </Tab.Content>
              </Row>
            </Tab.Container>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ComplaintListTable;
